import FormValidation from "../Validation/FormValidation";

const Texts = {

    bind(form) {
        this.inputs = 'input[type="text"], input[type="number"], input[type="password"], input[type="url"], textarea'
        form.find(this.inputs).on('keyup change paste', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });
    },

    check(form) {
        let ok = true;
        form.find(this.inputs).not('.chosen-search-input').each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el), this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');
        const isNumber = input.is('[type="number"]');
        const isPercent = input.is('.percent');

        if (isNumber && isRequired && isPercent) return parseInt(input.val()) === 100;
        else if (isNumber && isRequired) return !!input.val()
        else if (isRequired) return input.val().length >= 3
        else return true;

    },
}

export default Texts;